// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({

  name: 'authentication',
  initialState: {
    userData: initialUser(),
    currentUser: ''
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = action.payload
      state.currentUser = action.payload
      localStorage.setItem('userData', JSON.stringify(action.payload))

    },
    handleLogout: state => {
      state.userData = {}
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      Cookies.remove('XSRF-TOKEN')
      Cookies.remove('conformed_session')
    }
  }
})

export const { handleLogin, handleLogout } = authSlice.actions

export default authSlice.reducer
